import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 STEP: Create the Turbonomic Operator`}</h2>
    <a href="https://www.ibm.com/docs/en/tarm/8.7.5?topic=clusters-installing-using-red-hat-openshift-operatorhub" target="_blank">🌏 Documentation for the Task: Create the Turbonomic Operator (Start at Step 4.)</a>
    <p>{`In this section you will install the Turbonomic Operator using the Openshift OperatorHub.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the `}<strong parentName="p">{`Operators `}{`>`}{` OperatorHub`}</strong>{` page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the `}<strong parentName="p">{`Filter by keyword`}</strong>{` box, enter `}<inlineCode parentName="p">{`turbonomic`}</inlineCode>{` to find and select the Turbonomic Platform Operator.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`Turbonomic Platform Operator`}</inlineCode>{`, ensure you select the `}<inlineCode parentName="p">{`Certified`}</inlineCode>{` edition. `}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/01_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Install`}</strong>{`.`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/02_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under `}<inlineCode parentName="p">{`Installed Namespace`}</inlineCode>{` click `}<inlineCode parentName="p">{`Select Project`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/03_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create Project`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/04_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Name the Project `}<inlineCode parentName="p">{`turbonomic`}</inlineCode>{` and click `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/05_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Install`}</inlineCode>{`. This will install the Turbonomic Operator.`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/06_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`View installed Operators in Namespace turbonomic`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/07_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Wait until the Status is `}<inlineCode parentName="p">{`Succeeded`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/08_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <h2>{`🚀 STEP: Delete existing ClusterRolesBindings`}</h2>
    <p>{`In some environments that can be provisioned in TechZone, a Turbonomic Agent is already installed.
In order to install Turbonomic in this cluster please execute the following.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open your Openshift Web Console`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on the `}<inlineCode parentName="p">{`+`}</inlineCode>{` in the upper right corner`}</p>
        <img parentName="li" {...{
          "src": "./../images/prereqs/01_prereqs.png",
          "alt": "image"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy and paste the following code`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-yaml"
          }}>{`---
kind: ClusterRoleBinding
apiVersion: rbac.authorization.k8s.io/v1
metadata:
  name: installer-default-default-admin
roleRef:
  apiGroup: rbac.authorization.k8s.io
  kind: ClusterRole
  name: cluster-admin
subjects:
  - kind: ServiceAccount
    name: default
    namespace: default
---
apiVersion: batch/v1
kind: Job
metadata:
  name: prepare-turbonomic
  namespace: default
spec:
  serviceAccountName: installer-default-default-admin
  template:
    spec:
      containers:
        - name: install
          image: docker.io/niklaushirt/ibm-aiops-tools:2.0
          imagePullPolicy: IfNotPresent
          resources:
            requests:
              memory: "64Mi"
              cpu: "150m"
            limits:
              memory: "1256Mi"
              cpu: "1200m"
          command:
            - /bin/sh
            - -c
            - |                
              oc delete ClusterRoleBinding turbo-all-binding --ignore-not-found=true
      restartPolicy: Never
  backoffLimit: 4
---
kind: ClusterRoleBinding
apiVersion: rbac.authorization.k8s.io/v1
metadata:
  name: turbonomic-admin1
subjects:
  - kind: ServiceAccount
    name: t8c-operator
    namespace: turbonomic
roleRef:
  apiGroup: rbac.authorization.k8s.io
  kind: ClusterRole
  name: cluster-admin
---
kind: ClusterRoleBinding
apiVersion: rbac.authorization.k8s.io/v1
metadata:
  name: turbonomic-admin2
subjects:
  - kind: ServiceAccount
    name: turbo-user
    namespace: turbonomic
roleRef:
  apiGroup: rbac.authorization.k8s.io
  kind: ClusterRole
  name: cluster-admin
---
kind: ClusterRoleBinding
apiVersion: rbac.authorization.k8s.io/v1
metadata:
  name: turbonomic-admin3
subjects:
  - kind: ServiceAccount
    name: default
    namespace: turbonomic
roleRef:
  apiGroup: rbac.authorization.k8s.io
  kind: ClusterRole
  name: cluster-admin

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      